import gql from "graphql-tag"
import { SURVEY_AREA_DETAIL_FRAG } from "./survey-areas-fragments.gql"

export const ALL_SURVEY_AREAS = gql`
  query AllSurveyAreas(
    $query: String
    $first: Int
    $skip: Int
    $filter: SurveyAreaFilterInput
  ) {
    allSurveyAreas(query: $query, first: $first, skip: $skip, filter: $filter) {
      ...SurveyAreaDetailFrag
    }
  }
  ${SURVEY_AREA_DETAIL_FRAG}
`

export const ALL_SURVEY_AREAS_PREIVEW = gql`
  query AllSurveyAreasPreview(
    $query: String
    $first: Int
    $skip: Int
    $filter: SurveyAreaFilterInput
  ) {
    allSurveyAreas(query: $query, first: $first, skip: $skip, filter: $filter) {
      id
      geometry {
        coordinates
      }
    }
  }
`
export const SURVEY_AREA_DETAIL = gql`
  query SurveyAreaDetail($id: ID!) {
    surveyAreaDetail(id: $id) {
      ...SurveyAreaDetailFrag
    }
  }
  ${SURVEY_AREA_DETAIL_FRAG}
`

export const ALL_SALESMAN = gql`
  query AllSalesMan {
    usersByGroup(groupName: "Salesman") {
      id
      fullName
      number
    }
  }
`

export const MY_DCS = gql`
  query MyDcs {
    me {
      distributionCentres {
        id
        name
        colorCode
        geometry {
          type
          coordinates
        }
      }
    }
  }
`

export const DC_PINCODES = gql`
  query DcPincodes(
    $query: String
    $first: Int
    $skip: Int
    $filter: SurveyAreaFilterInput
  ) {
    allSurveyAreas(query: $query, first: $first, skip: $skip, filter: $filter) {
      id
      properties {
        id: codename
        name
        distributionCentre {
          id
          name
        }
      }
    }
  }
`
